<template>
  <div>
    <div class="d-flex justify-space-between">
      <back-button /> <delete-button v-if="id" @click="del()" />
    </div>
    <v-progress-linear v-if="loading" indeterminate />
    <div v-else>
      <page-header>{{ user.name || "Добавить пользователя" }}</page-header>
      <user-form :user="user" @submit="submitForm" />
    </div>
  </div>
</template>

<script>
import api from "../api";
import axios from "axios";
import UserForm from "../components/UserForm";
import BackButton from "../components/BackButton";
import PageHeader from "../components/PageHeader";
import store from "../store";
import DeleteButton from "../components/DeleteButton";

export default {
  name: "partner",
  components: {
    UserForm,
    BackButton,
    PageHeader,
    DeleteButton
  },
  data() {
    return {
      user: {},
      loading: false
    };
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    }
  },
  methods: {
    del() {
      if (confirm("Вы уверены, что хотите удалить?")) {
        this.loading = true;
        axios
          .delete(`${api.users}/${this.id}`)
          .then(() => {
            store.snackbar = true;
            store.snackbarSuccess = true;
            store.snackbarMessage = "Пользователь удалён";
            this.$router.push({ name: "users" });
          })
          .catch(err => {
            store.snackbar = true;
            store.snackbarMessage = err.message;
            store.snackbarSuccess = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getItem() {
      this.loading = true;
      axios
        .get(`${api.users}/${this.id}`)
        .then(resp => {
          this.user = resp.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitForm(user) {
      this.loading = true;

      if (this.id) {
        // обновляем
        axios
          .put(`${api.users}/${this.id}`, user)
          .then(resp => {
            this.user = resp.data;
            store.snackbar = true;
            store.snackbarMessage = "Пользователь обновлён";
            store.snackbarSuccess = true;
            this.$router.push({ name: "users" });
          })
          .catch(err => {
            store.snackbar = true;
            store.snackbarMessage = `${err.response.data[0].field}:${err.response.data[0].message}`;
            store.snackbarSuccess = false;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        // или создаём
        axios
          .post(api.users, user)
          .then(() => {
            store.snackbar = true;
            store.snackbarMessage = "Пользователь добавлен";
            store.snackbarSuccess = true;
            this.$router.push({ name: "users" });
          })
          .catch(err => {
            store.snackbar = true;
            store.snackbarMessage = `${err.response.data[0].field}:${err.response.data[0].message}`;
            store.snackbarSuccess = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
  mounted() {
    if (this.id) this.getItem();
  }
};
</script>

<style></style>
